export default __webpack_public_path__ + "static/media/discover.c586cba0.png";